import { translate } from '../../../Internationalization';
import ExternalAnchorButton from '../../../../shared/ExternalAnchorButton';
import React from 'react';

/**
 * @param {{phone:	string|null, email: string|null}} props
 * @returns {JSX.Element | JSX.Element[]}
 */
export default function AgentCardCta(props) {
	const cta = [];

	if (props?.phone) {
		cta.push(['call', `tel:${props?.phone}`]);
	}

	if (props?.email) {
		cta.push(['email', `mailto:${props?.email}`]);
	}

	return (
		<footer className="button-group">
			{cta.map((link) => (
				<ExternalAnchorButton
					className="button button-outline"
					href={link[1]}
					key={link[1]}
				>
					{translate(`homeowner.pages.dashboard.agent.${link[0]}`)}
				</ExternalAnchorButton>
			))}
		</footer>
	);
}
